import {
    CustomerCreateRequest,
    CustomerResponse
} from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import axios from 'axios'

class BillingCommonCustomerService {
    async getActiveCustomers(
        laboratoryId: number,
        billableConceptId: number
    ): Promise<CustomerResponse[]> {
        const response =
            await axios.get<CustomerResponse[]>(
                `/billing/laboratories/${laboratoryId}/customers`,
                {
                    params: {
                        billableConceptId
                    }
                })
        return response.data
    }

    async paginator(
        filterModel: CommonFilterModel | undefined,
        params: CommonParams | undefined,
        laboratoryId: number
    ): Promise<IResponseAgGrid<CustomerResponse>> {
        const response =
            await axios.put<IResponseAgGrid<CustomerResponse>>(
                `/billing/laboratories/${laboratoryId}/customers`,
                { ...filterModel },
                { params })
        return response.data
    }

    async create(
        laboratoryId: number,
        request: CustomerCreateRequest
    ): Promise<CustomerResponse> {
        const response =
            await axios.post<CustomerResponse>(
                `/billing/laboratories/${laboratoryId}/customers`,
                request)
        return response.data
    }
}
export const billingCommonCustomerService = new BillingCommonCustomerService()
